export const recapthcaKey = '6Lc4Dt4cAAAAAAkcVDqbFX8DWJrNWbpxL8bI2tdm';
